import Script from 'next/script';

import { useBooleanFlags } from '@/core/flags/flags.hooks';

import { getAppSetting } from '../settings/appSettings';

export const CONSTRUCTOR_FLAG_NAME = 'enableConstructorPoc';
const CUSTOM_BUNDLE_NAME = getAppSetting('CONSTRUCTOR_CUSTOM_BUNDLE_NAME');

export const ConstructorScript = () => {
  const [enabled] = useBooleanFlags([CONSTRUCTOR_FLAG_NAME]);

  if (!enabled || !CUSTOM_BUNDLE_NAME) {
    return null;
  }

  return (
    <Script
      defer
      id="constructor"
      strategy="lazyOnload"
      src={`https://cnstrc.com/js/cust/${CUSTOM_BUNDLE_NAME}.js`}
      async
    />
  );
};
